// Single source of truth for the default homeserver URL
export const DEFAULT_HOMESERVER = 'https://matrix-synapse.netsferedev.com';
